import Users from "@/modules/users";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/_layout/users/")({
  component: Users,
});
